import { ResetPasswordForm } from '@/components/auth/reset-password-form'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_public/reset-password')({
  component: ResetPasswordPage,
})

function ResetPasswordPage(): JSX.Element {
  return <ResetPasswordForm />
}
